<template>
  <div class="site-navigation-page">
    <!-- 顶部关闭栏 -->
    <div class="nav-header">
      <div class="nav-header-inner">
        <img
          class="nav-logo"
          referrerpolicy="no-referrer"
          :src="require('../detail/assets/img/red_logo.png')"
          @click="goHome"
        />
        <span class="nav-slogan">让品牌动力中国</span>
        <span class="nav-close" @click="goBack">×</span>
      </div>
    </div>

    <!-- 内容区 -->
    <div class="nav-content">
      <!-- 中国品牌融媒体 -->
      <div class="nav-section">
        <h3 class="nav-section-title">中国品牌融媒体</h3>
        <div class="media-grid">
          <a
            v-for="(link, index) in friendLinks"
            :key="'media-' + index"
            class="media-item"
            :data-media-index="index"
            :href="link.url && link.url !== '#' ? link.url : 'javascript:;'"
            :target="link.url && link.url !== '#' ? '_blank' : '_self'"
            @click.stop.prevent="handleMediaClick(link, index, $event)"
          >
            <img 
              class="media-icon" 
              referrerpolicy="no-referrer" 
              :src="link.imageUrl"
              :alt="link.name"
              @load="handleMediaIconLoad(index)"
              @error="handleMediaIconError(index)"
              :class="{ 'img-loading': !link.loaded }"
            />
            <span v-if="!link.loaded && link.isLoading" class="img-placeholder">加载中...</span>
            <span v-if="link.error" class="img-default">暂无图片</span>
            <span class="media-name">{{ link.name }}</span>
          </a>
        </div>
      </div>

      <!-- 二维码弹层：链接地址为图片时展示 -->
      <div
        v-if="showQrPopup && currentQrLink"
        class="qr-popup"
        :style="qrPopupPosition"
        @click.stop
      >
        <div class="qr-popup-card">
          <span
            class="qr-popup-arrow"
            :class="{ 'qr-popup-arrow--bottom': qrArrowAtBottom }"
          ></span>
          <div class="qr-popup-body">
            <img
              class="qr-popup-image"
              referrerpolicy="no-referrer"
              :src="currentQrLink.url"
              :alt="currentQrLink.name"
              @error="qrImageError = true"
              @load="qrImageError = false"
            />
            <span v-if="qrImageError" class="qr-popup-error">二维码加载失败</span>
            <span class="qr-popup-desc">{{ currentQrLink.name }}</span>
          </div>
        </div>
      </div>

      <!-- 中国品牌网 -->
      <div class="nav-section">
        <h3 class="nav-section-title">中国品牌网</h3>
        <div class="category-grid">
          <span
            v-for="(item, index) in categories"
            :key="'cat-' + index"
            class="category-item"
            @click="goCategory(item)"
          >{{ item.name }}</span>
        </div>
      </div>

      <!-- 中国品牌杂志社 -->
      <div class="nav-section">
        <h3 class="nav-section-title">中国品牌杂志社</h3>
        <div class="link-row">
          <router-link to="/about-us" class="text-link">公司简介</router-link>
          <router-link to="/ad-service" class="text-link">刊例价</router-link>
        </div>
      </div>

      <!-- 关于我们 -->
      <div class="nav-section">
        <h3 class="nav-section-title">关于我们</h3>
        <div class="link-row">
          <router-link to="/about-us" class="text-link">公司简介</router-link>
          <router-link to="/ad-service" class="text-link">刊例价</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import request from '../detail/api/request'

export default {
  name: 'SiteNavigation',
  data() {
    return {
      friendLinks: [],
      categories: [],
      DEFAULT_IMAGE: require('../../assets/images/default/default-news.png'),
      // 二维码弹层
      showQrPopup: false,
      currentQrLink: null,
      qrPopupPosition: {},
      qrArrowAtBottom: false,
      qrImageError: false
    }
  },
  created() {
    this.loadFriendLinks()
    this.loadCategories()
  },
  mounted() {
    document.addEventListener('click', this.handleDocumentClick)
    window.addEventListener('scroll', this.closeQrPopup, true)
    window.addEventListener('resize', this.closeQrPopup)
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleDocumentClick)
    window.removeEventListener('scroll', this.closeQrPopup, true)
    window.removeEventListener('resize', this.closeQrPopup)
  },
  methods: {
    async loadFriendLinks() {
      try {
        const res = await request.post('/api/index/getFriendLink')
        if (res.code === 200 && Array.isArray(res.data)) {
          this.friendLinks = res.data.map(item => ({
            id: item.id,
            name: item.name,
            imageUrl: item.imageUrl || this.DEFAULT_IMAGE,
            url: item.url,
            loaded: false,       // 是否已加载完成
            isLoading: true,     // 是否正在加载
            error: false         // 是否加载失败
          }))
        }
      } catch (error) {
        console.error('加载友情链接失败', error)
      }
    },
    async loadCategories() {
      try {
        const res = await request.post('/api/index/getCategory')
        const list = res.data || []
        this.categories = [
          { id: 0, name: '首页', categoryTemplatePath: '/' },
          ...list.sort((a, b) => (a.sortOrder || 0) - (b.sortOrder || 0))
        ]
      } catch (error) {
        console.error('加载导航分类失败', error)
      }
    },
    goHome() {
      this.$router.push('/')
    },
    goBack() {
      this.$router.go(-1)
    },
    goCategory(item) {
      if (item.name === '电子杂志') {
        this.$router.push('/magazine')
        return
      }
      if (item.id === 0) {
        this.$router.push('/')
        return
      }
      if (item.categoryTemplatePath) {
        window.location.href = `${item.categoryTemplatePath}?categoryId=${item.id}`
      }
    },
    handleMediaIconLoad(index) {
      if (this.friendLinks[index]) {
        this.friendLinks[index].loaded = true
        this.friendLinks[index].isLoading = false
      }
    },
    handleMediaIconError(index) {
      if (this.friendLinks[index]) {
        this.friendLinks[index].error = true
        this.friendLinks[index].isLoading = false
        this.friendLinks[index].imageUrl = this.DEFAULT_IMAGE
      }
    },
    // 判断是否为图片地址（支持带 query 参数的地址，如 OSS 处理参数）
    isImageUrl(url) {
      if (!url || url === '#') return false
      const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.bmp', '.svg']
      let lowerUrl = String(url).toLowerCase()
      if (!lowerUrl.startsWith('http')) return false
      // 去掉 ?query 与 #hash 后再判断扩展名
      const hashIndex = lowerUrl.indexOf('#')
      if (hashIndex !== -1) lowerUrl = lowerUrl.slice(0, hashIndex)
      const queryIndex = lowerUrl.indexOf('?')
      if (queryIndex !== -1) lowerUrl = lowerUrl.slice(0, queryIndex)
      return imageExtensions.some(ext => lowerUrl.endsWith(ext))
    },
    // 点击融媒体项：图片地址弹出二维码，普通地址新窗口打开
    handleMediaClick(link, index, event) {
      if (!link.url || link.url === '#') return

      if (this.isImageUrl(link.url)) {
        // 再次点击同一项则关闭
        if (this.showQrPopup && this.currentQrLink && this.currentQrLink.id === link.id) {
          this.closeQrPopup()
          return
        }
        this.qrImageError = false
        this.currentQrLink = link
        this.showQrPopup = true
        this.updateQrPopupPosition(event && event.currentTarget)
        return
      }

      this.closeQrPopup()
      window.open(link.url, '_blank', 'noopener,noreferrer')
    },
    updateQrPopupPosition(el) {
      if (!el) {
        this.qrPopupPosition = {}
        return
      }
      const rect = el.getBoundingClientRect()
      const popupWidth = 160
      const popupHeight = 200
      const gap = 12

      let left = rect.left + rect.width / 2 - popupWidth / 2
      const maxLeft = window.innerWidth - popupWidth - 8
      left = Math.min(Math.max(8, left), Math.max(8, maxLeft))

      let top = rect.bottom + gap
      let arrowAtBottom = false
      // 下方空间不足时，弹层显示在元素上方
      if (top + popupHeight > window.innerHeight - 8) {
        top = rect.top - popupHeight - gap
        arrowAtBottom = true
        if (top < 8) top = 8
      }

      this.qrArrowAtBottom = arrowAtBottom
      this.qrPopupPosition = { top: `${top}px`, left: `${left}px` }
    },
    closeQrPopup() {
      this.showQrPopup = false
      this.currentQrLink = null
      this.qrArrowAtBottom = false
    },
    handleDocumentClick(event) {
      if (!this.showQrPopup) return
      const popup = event.target && event.target.closest && event.target.closest('.qr-popup')
      if (!popup) {
        this.closeQrPopup()
      }
    }
  }
}
</script>

<style scoped>
.site-navigation-page {
  min-height: 100vh;
  background: #DFDFE6;
  padding-bottom: 60px;
}

/* 顶部关闭栏 */
.nav-header {
  width: 100%;
  background: #DFDFE6;
}
.nav-header-inner {
  width: 1400px;
  margin: 0 auto;
  height: 130px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}
.nav-logo {
  width: 147px;
  height: 58px;
  cursor: pointer;
}
.nav-slogan {
  font-size: 24px;
  color: #333;
  margin-left: 38px;
  letter-spacing: 2px;
  font-family: Microsoft YaHei UI-Regular;
}
.nav-close {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  font-size: 48px;
  color: #999;
  cursor: pointer;
  line-height: 1;
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.2s;
}
.nav-close:hover {
  color: #C00513;
}

/* 内容区 */
.nav-content {
  width: 1400px;
  margin: 0 auto;
  padding-top: 20px;
}

.nav-section {
  margin-bottom: 50px;
}
.nav-section-title {
  font-size: 22px;
  color: #C00513;
  font-weight: 600;
  margin-bottom: 24px;
  font-family: Microsoft YaHei-Regular;
}

/* 融媒体网格 */
.media-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 30px 40px;
}
.media-item {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  text-decoration: none;
  cursor: pointer;
}
.media-icon {
  width: 56px;
  height: 56px;
  border-radius: 8px;
  object-fit: cover;
  opacity: 1;
  transition: opacity 0.3s ease;
}

/* 加载中状态 */
.img-loading {
  opacity: 0.3;
}

/* 图片占位符 - 居中显示 */
.img-placeholder,
.img-default {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 12px;
  color: #999;
  z-index: 1;
}

/* 重新加载按钮 */
.img-error-btn {
  position: absolute;
  bottom: 8px;
  right: 8px;
  padding: 3px 10px;
  background: rgba(0, 0, 0, 0.6);
  color: #fff;
  border-radius: 12px;
  font-size: 10px;
  cursor: pointer;
  z-index: 2;
  transition: all 0.2s;
}

.img-error-btn:hover {
  background: rgba(0, 0, 0, 0.8);
}
.media-name {
  font-size: 14px;
  color: #666;
  font-family: Microsoft YaHei-Regular;
}
.media-item:hover .media-name {
  color: #C00513;
}

/* ===== 二维码弹层 ===== */
.qr-popup {
  position: fixed;
  z-index: 9999;
  pointer-events: auto;
}
.qr-popup-card {
  position: relative;
  background: #FFFFFF;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  width: 160px;
  padding: 12px;
  box-sizing: border-box;
}
.qr-popup-arrow {
  position: absolute;
  top: -6px;
  left: 50%;
  transform: translateX(-50%) rotate(45deg);
  width: 14px;
  height: 14px;
  background: #FFFFFF;
  border-radius: 3px;
  box-shadow: -2px -2px 6px rgba(0, 0, 0, 0.05);
}
.qr-popup-arrow--bottom {
  top: auto;
  bottom: -6px;
  box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.05);
}
.qr-popup-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}
.qr-popup-image {
  width: 130px;
  height: 130px;
  object-fit: contain;
  border-radius: 4px;
  background: #F5F5F5;
}
.qr-popup-error {
  font-size: 12px;
  color: #FF4D4F;
  line-height: 18px;
}
.qr-popup-desc {
  font-size: 12px;
  color: #666;
  line-height: 18px;
  text-align: center;
  max-width: 100%;
  word-break: break-all;
}

/* 中国品牌网分类网格 */
.category-grid {
  display: grid;
  grid-template-columns: repeat(10, 1fr);
  gap: 16px 24px;
}
.category-item {
  font-size: 18px;
  color: #333;
  cursor: pointer;
  font-family: Microsoft YaHei-Regular;
  transition: color 0.2s;
}
.category-item:hover {
  color: #C00513;
}

/* 链接行 */
.link-row {
  display: flex;
  gap: 40px;
}
.text-link {
  font-size: 18px;
  color: #333;
  text-decoration: none;
  font-family: Microsoft YaHei-Regular;
  transition: color 0.2s;
}
.text-link:hover {
  color: #C00513;
}
</style>
